import Lottie from 'lottie-react';
import loading from '../../../assets/animations/loading.json';

export const AnimateLoading = () => {
  return (
    <div className={'w-full h-[100vh] flex justify-center items-center bg-white/75 pb-[200px]'}>
      <Lottie style={{ width: '50px', height: '50px' }} animationData={loading} loop autoPlay />
    </div>
  );
};
